import { Injectable } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { take } from 'rxjs';
import { LangchainPublicGate } from '../../../../../backend/src/core/langchain/langchain.public.gate';
import {
  CreateMessageRequest,
  CreateRunRequest,
  CreateThreadRequest,
  GetAnswerRequest,
  ListMessagesRequest,
  OpenaiGate,
  RetrieveMessageRequest,
  RetrieveRunRequest,
  StreamingChatRequest,
} from '../../../../../backend/src/core/openai/openai.gate';
import { ResourceName } from '../../../../../backend/src/core/resource-name';
import { LambdaService } from '../../shared/core/lambda.service';
import { BoardHolderService } from './../board/board.holder.service';
import { WorkspaceHolderService } from './../workspace/workspace.holder.service';
import { OpenaiAssistant, OpenaiMessage } from './openai';

@Injectable({
  providedIn: 'root',
})
export class OpenaiService {
  constructor(
    private lambdaService: LambdaService,
    private boardHolderService: BoardHolderService,
    private workspaceHolderService: WorkspaceHolderService,
    private msg: NzMessageService
  ) {}

  getLangchain() {
    this.lambdaService
      .run$(ResourceName.langchain, LangchainPublicGate.actions.callOpenAi, {}, { isPublicUrl: true })
      .pipe(take(1))
      .subscribe();
  }

  streamingChat$(
    coreId: string,
    messageList: OpenaiMessage[],
    config?: { model?: string; temperature?: number; additionalId?: string }
  ) {
    const request: StreamingChatRequest = {
      coreId,
      additionalId: config?.additionalId,
      personalBoardId: this.boardHolderService.myPersonalBoard()!.id,
      workspaceId: this.workspaceHolderService.currentWorkspace().id,
      messageList: messageList,
      config: {
        model: config?.model,
        temperature: config?.temperature,
      },
    };

    return this.lambdaService.run$(ResourceName.openai, OpenaiGate.actions.streamingChat, request);
  }

  getAnswer$(request: GetAnswerRequest, notChangeLoadingStatus = false) {
    return this.lambdaService.run$(ResourceName.openai, OpenaiGate.actions.getAnswer, request, {
      notChangeLoadingStatus,
    });
  }

  createAssistant$(assistant: Partial<OpenaiAssistant>) {
    return this.lambdaService.run$(ResourceName.openai, OpenaiGate.actions.createAssistant, assistant);
  }

  createThread$(request?: CreateThreadRequest) {
    return this.lambdaService.run$(ResourceName.openai, OpenaiGate.actions.createThread, request);
  }

  createMessage$(request: CreateMessageRequest) {
    return this.lambdaService.run$(ResourceName.openai, OpenaiGate.actions.createMessage, request);
  }

  retrieveMessage$(request: RetrieveMessageRequest) {
    return this.lambdaService.run$(ResourceName.openai, OpenaiGate.actions.retrieveMessage, request);
  }

  listMessages$(request: ListMessagesRequest) {
    return this.lambdaService.run$(ResourceName.openai, OpenaiGate.actions.listMessages, request);
  }

  retrieveRun$(request: RetrieveRunRequest) {
    return this.lambdaService.run$(ResourceName.openai, OpenaiGate.actions.retrieveRun, request, {
      notChangeLoadingStatus: true,
    });
  }

  createRun$(request: CreateRunRequest) {
    return this.lambdaService.run$(ResourceName.openai, OpenaiGate.actions.createRun, request);
  }
}
